<template>
    <div ref="reference">
        <slot></slot>
        <panel
            v-if="show"
            ref="floatingPanel"
            :styles="floatingStyles"
            :collections="collections"
            :marker="marker"
            @refresh="fetchData"
        ></panel>
    </div>
</template>

<script setup>
    import { ref, reactive, provide, onMounted, getCurrentInstance, nextTick} from 'vue';
    import { useFloating, autoPlacement, offset, shift, size, apply } from '@floating-ui/vue';
    import Panel from './Panel.vue'

    const ctx = getCurrentInstance();
    const collections = reactive({data: []});
    const show = ref(false);
    const reference = ref(null);
    const floatingPanel = ref(null);
    const oldMarker = ref(null)
    const marker = ref(null)

    const {floatingStyles} = useFloating(reference, floatingPanel, {
        middleware: [
            offset(5),
            shift(),
            autoPlacement({
                alignment: "left-start"
            }),
        ]
    });

    nextTick(() => {
        document.getElementById('mapDiv').addEventListener('click', () => {
            show.value = false;
        })
    })

    onMounted(() => {
        fetchData();
    })

    provide('parentShow', show)

    provide('signalWrapper', (publicId, target) => {

        /**
         * this is the html element from the root refs
         */
        // reference.value = ctx.proxy?.$root?.$refs[target]

        if (oldMarker.value != publicId) {
            show.value = !show.value
        }

        oldMarker.value = publicId

        show.value = true;

        toggleToolActive(ctx.proxy?.$root?.$refs[target])

        marker.value = {
            publicId, target
        }
    })

    function toggleToolActive(element) {
        try {
            document.querySelectorAll(".geo-type.tool-active")
                .forEach((el) => el.classList.remove("tool-active"))

            element.classList.add('tool-active')
        } catch (error) {
            console.error('unable to toggle class', error)
        }
    }

    function fetchData() {
        axios.get('/collections')
            .then(response => {
                collections.data = response.data.data
            })
            .catch(error => {
                console.error(error)
            })
    }
</script>

<style scoped>
 .panel {
    margin-top: 8px;
    position: absolute;
    left: 0px;
    top: 0px;
    transform: none;
    will-change: transform;
}
</style>
